import React from 'react';
import client from '../../../../lib/client';
import { subjectMembersQuery, removeMemberFromSubjectMutation } from '../../../../queries/subjects';
import { Icon } from '../../../ui';
import {
  RemoveMemberFromSubjectMutation,
  RemoveMemberFromSubjectMutationVariables
} from '../../../../queries/__generated__/RemoveMemberFromSubjectMutation';

interface RemoveMemberButton {
  member: {
    id: string;
  };
  subject: {
    id: string;
  };
}

const RemoveMemberButton: React.FC<RemoveMemberButton> = ({ member, subject }) => {
  function removeMemberFromSubject() {
    client.mutate<RemoveMemberFromSubjectMutation, RemoveMemberFromSubjectMutationVariables>({
      mutation: removeMemberFromSubjectMutation,
      variables: { input: { subjectId: subject.id, memberId: member.id } },
      refetchQueries: [
        { query: subjectMembersQuery, variables: { input: { subjectId: subject.id } } }
      ]
    });
  }

  return (
    <button onClick={removeMemberFromSubject} data-testid="remove-member-button">
      <Icon name="close" size={18} />
    </button>
  );
};

export default RemoveMemberButton;
